import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Axios from "axios";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LoginAPIURL } from '../apiconstants/constants';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
// import "./login.css";
import logo from "../assets/images/knackhire-new.png"
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import BeforeLoginHeader from '../commonlayouts/beforeloginheader';
import FooterLayout from '../commonlayouts/beforeloginfooter';
import Swal from 'sweetalert2';

function SuperAdminLogin() {
  const formSchema = Yup.object().shape({
    email: Yup.string().email().required(),
    password: Yup.string()
      .required('Password is mandatory')
  })

 
  const formOptions = { resolver: yupResolver(formSchema) }
  const { register, handleSubmit, reset, setValue, formState } = useForm(formOptions);
  const { errors } = formState;
  const { isSubmitting } = formState;
  const apiUrl = LoginAPIURL.APIURL;
  const [roleid, setRoleID] = React.useState(2);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const onSubmit = (data, e) => {
    e.preventDefault();
    e.target.reset();

    setIsLoading(true);

    const fliterdata = {
       email: data.email,
       password: data.password, 
       guid: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
       roleID: 5
      };
       Axios.post(apiUrl, fliterdata)
      .then((result) => {
        setIsLoading(false);
       
        if (result.data.message === 'Success'&&result.data.roleID==5) {
            navigate("/Admin/ListofallClients")
        }
            if (result.data.message === 'Not Authorized') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Select Correct Role option',
            showConfirmButton: false,
            timer: 5000
          })
        }
        else if(result.data.message==="Email or password is incorrect") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Invalid User Name or Password, Please check your Email.',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Invalid User Name or Password, Please check your Email.', { autoClose: 5000 })
        }
        else if(result.data.message==="User Deactivated") {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'User is Deactivated',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.error('Invalid User Name or Password, Please check your Email.', { autoClose: 5000 })
        }

      }).catch(function (error) {
        console.log("Error" + error)
        setIsLoading(false)
      })

    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }

 
  return (
    <><div>
          <>
              <nav class="navbar navbar-light bg-light justify-content-between">
                  <Link to="/home"> <img src={logo} height={50} alt="Logo" />
                  </Link>
                  <div class="bb">

                  </div>
              </nav>
              {isLoading ? (
                  <center>
                      <LoadingSpinner />
                  </center>
              ) : (
                  <div className="container mt-5 mb-5">
                      <div
                          style={{
                              width: "400px",
                              height: "500px",
                              margin: "auto",
                              paddingTop: "40px",
                              paddingBottom: "40px",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              background: "#f8f8f8",
                              border: "1px solid #00a7ac26",
                              borderRadius: 20,
                          }}
                      >

                          <form onSubmit={handleSubmit(onSubmit)} id="loginform">
                              <div className="row p-5">
                            <h3 className="text-center mb-3" style={{ color: "#00a7ac" }}>Login</h3>
                                      <div className="mb-3 mt-3">
                                          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Email</Tooltip>)}>
                                              <input
                                                  placeholder='Email'
                                                  type="email"
                                                  name="email"
                                                  {...register("email")}
                                                  className={`form-control shadow-sm ${errors.email ? 'is-invalid' : ''}`} />
                                          </OverlayTrigger>
                                          <div className="invalid-feedback"> {errors.email?.message}</div>
                                      </div>

                                      <div className="mb-3 mt-4">
                                          <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Password</Tooltip>)}>
                                              <input
                                                  placeholder='Password'
                                                  type="password"
                                                  name="password"
                                                  {...register("password")}
                                                  style={{ fontWeight: "bold", fontSize: 22 }}
                                                  className={`form-control shadow-sm ${errors.password ? 'is-invalid' : ''}`} />
                                          </OverlayTrigger>
                                          <div className="invalid-feedback">{errors.password?.message}</div>
                                      </div>

                                      <div>
                                          <ul style={{ listStyle: "none" }} className='d-flex justify-content-between'>

                                              <li>
                                                  <Link to="/account/ForgotPassword" style={{ fontSize: 14, fontWeight: "bold", color: "#00a7ac" }}>Forgot Password</Link>
                                              </li>

                                          </ul>
                                      </div>
                                      <div className='text-center'>
                                          <button
                                              disabled={isSubmitting}
                                              className="btn btn-primary mt-3"
                                              style={{ backgroundColor: "#00a7ac", border: "none", borderRadius: 15 }}
                                          >
                                              {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                                              Login
                                          </button>
                                      </div>
                                  </div>
                             
                          </form>
                      </div>

                  </div>
              )}
          </></div><div style={{marginTop:150}}><FooterLayout /></div></>
  
  )
}

export default SuperAdminLogin;
